
import { get, put, post, del } from './connection'

const API_BASE_URL = process.env.REACT_APP_API_URL;
const masterApi = {

    login: async (requestData) => {
        try {
            const response = await post(`/auth/login`, requestData.data);
            
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },

    createUser: async (requestData) => {
        try {
            
            const response = await post(`/auth/createuser`, requestData.formData,'form');
           
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },

    updateUser: async (requestData) => {
        try {
           
            const response = await put(`/auth/edit-user/${requestData.userId}`, requestData.formData,'form');
            
            return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },

    getUsersByRole: async (data ) => {
        try {
            const response = await get(`/auth/get-users-by-role/${data.userRoleValue}`);
           return response;
        } catch (error) {
            throw new Error("Error while deleteing user");
        }
    },

    deleteUser: async (deleteData ) => {
        try {
            const response = await del(`/auth/delete-user/${deleteData.userId}`);
           return response;
        } catch (error) {
            throw new Error("Error while deleteing user");
        }
    },

    
    getStage: async (id) => {
        try {
            const response = get("/getstagebyid/:"+id);
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },

    deleteUser: async (deleteData ) => {
        try {
            const response = await del(`/auth/delete-user/${deleteData.userId}`);
           return response;
        } catch (error) {
            throw new Error("Error while deleteing user");
        }
    },

    createStage: async (requestData) => {
        try {
            const response = post(`/master/add-stage`, requestData.formattedData);
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },
    uploadStageImage: async (requestData) => {
        try {
            const response = await post(`/master/upload-stage-image`, requestData.formData,'form');
           return response;
        } catch (error) {
            throw new Error("Error while uploading stage image");
        }
    },

    updateStage: async (requestData) => {
        try {
            const response = await put(`/master/edit-stage/${requestData.stageId}`, requestData.formattedData);
            return response;
        } catch (error) {
            throw new Error("Error while updating new stage");
        }
    },

    getAllStages: async () => {
        try {
            const response = get(`/master/get-stages`);
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },

    getActiveStages: async () => {
        try {
            const response = get(`/master/get-active-stages`);
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },

    deleteStage: async (deleteData) => {
        try {
            const response = del(`master/delete-stage/${deleteData.stageId}`);
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },

    
    getExpertise: async (id) => {
        try {
            const response = get("/master/get-expertise/:"+id);
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },

    createExpertise: async (requestData) => {
        try {
            const response = post(`/master/add-expertise`, requestData.formattedData);
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },

    updateExpertise: async (requestData) => {
        try {
            const response = put(`/master/edit-expertise/${requestData.expertiseId}`, requestData.formattedData);
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },

    getAllExpertise: async () => {
        try {
            const response = get(`/master/get-all-expertise`);
           return response;
        } catch (error) {

            throw new Error("Error while creating new stage");
        }
    },

    deleteExpertise: async (deleteData) => {
        try {
            const response = del(`master/delete-expertise/${deleteData.expertiseId}`);
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },
    resetPassword: async (requestData) => {
        try {
            const response = post(`/auth/resetpassword`, requestData.data);
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },
    getUsersById: async (data ) => {
        try {
            //const response = await get(`/auth/get-users-by-role/${data.userRoleValue}`);
            const response = await get(`/auth/get-user-by-id/?userId=${data.userId}`);
           return response;
        } catch (error) {
            throw new Error("Error while fetching user");
        }
    },
    forgotPassword: async (requestData) => {
        try {
            const response = post(`/auth/forgotPassword`, requestData.data);
           return response;
        } catch (error) {
            throw new Error("Error in forgotpassword api call");
        }
    },
    resetPasswordWithLink: async (requestData) => {
        try {
            const response = post(`/auth/resetPasswordUsingResetLink`, requestData.formData);
           return response;
        } catch (error) {
            throw new Error("Error in forgotpassword api call");
        }
    },
    validateResetPasswordLink: async (requestData) => {
        try {
            const response = post(`/auth/validateResetPasswordLink`, requestData);
           return response;
        } catch (error) {
            throw new Error("Error in validate reset link");
        }
    },

    report: async (data ) => {
        try {
            let queryString=''
            if(data)
            {
                queryString = data;
            }
            const response = await get(`/report/ro-report/${queryString}`);
           return response;
        } catch (error) {
            throw new Error("Error while fetching report data");
        }
    },
    hardresetpassword: async (requestData) => {
        try {
            const response = post(`/auth/hardResetPassword`, requestData);
           return response;
        } catch (error) {
            throw new Error("Error in hard reset");
        }
    }
};

export default masterApi;